import StatsContainer from './containers/StatsContainer'

// Sync route definition
export default {
  path      : '/device/:device_string/stats',
  component : StatsContainer
}



// WEBPACK FOOTER //
// ./src/routes/Stats/index.jsx